import React, { Fragment, useState } from 'react';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';

const DownloadItemTab = ({
  resolutions,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [downloadEnabled, setDownloadEnabled] = useState(false);
  const onSubmit = (data) => {
    window.open(data['download-resolution'], '_self');
  };
  return (
    <Fragment>
      <div className="title-download">Escoge la calidad y el formato en el quieras descargar:</div>
      <form className="form" onSubmit={handleSubmit(onSubmit)} onChange={() => setDownloadEnabled(true)}>
        {resolutions != null && resolutions.map((resolution, index) => (
          <label htmlFor="resolution1">
            <input
              {...register('download-resolution')}
              type="radio"
              id="resolution1"
              value={resolution.src}
            />
            <span className="radio-btn__label">{resolution.description}</span>
          </label>
        ))}
        <input
          type="submit"
          className={`submit${downloadEnabled ? ' enabled' : ''}`}
          value="Descargar"
          disabled={!downloadEnabled}
        />
      </form>
    </Fragment>
  );
};

DownloadItemTab.propTypes = {
  resolutions: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    src: PropTypes.string,
    description: PropTypes.string,
  })).isRequired,
};

export default DownloadItemTab;
